import {DOM} from "../variables"

export const header = () => {
	console.log("header");
}